/**
 * Base Component Factory (Basics Skin)
 *
 * Creates basics-themed color-specific base components using the shared factory.
 * All 4 color variants (Red, Blue, Yellow, Green) are generated from a single implementation.
 */

import { createColoredBase, type ColoredBaseProps } from '../createBaseVariants';
import { BASE_COLOR_SCHEMES } from './constants/baseColorSchemes';
import { RedPawn, BluePawn, YellowPawn, GreenPawn } from '../../pawns/basics/pawnFactory';

// Generate all 4 color variants at module level (stable references)
export const RedBase = createColoredBase('red', BASE_COLOR_SCHEMES.red, RedPawn);
export const BlueBase = createColoredBase('blue', BASE_COLOR_SCHEMES.blue, BluePawn);
export const YellowBase = createColoredBase('yellow', BASE_COLOR_SCHEMES.yellow, YellowPawn);
export const GreenBase = createColoredBase('green', BASE_COLOR_SCHEMES.green, GreenPawn);

// Re-export ColoredBaseProps and type aliases for backward compatibility
export type { ColoredBaseProps };
export type { ColoredBaseProps as BlueBaseProps };
export type { ColoredBaseProps as RedBaseProps };
export type { ColoredBaseProps as GreenBaseProps };
export type { ColoredBaseProps as YellowBaseProps };
